import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { OtEventService } from '../ot-event.service';
import { OtEvent, Country, City, OtEventInfo } from '../../domain/ot-event';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { OtSessionService } from '../ot-session.service';
import { OtCityService } from '../ot-city.service';
import { CountryService } from 'src/app/services/country.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-ot-registration',
  templateUrl: './ot-registration-person.component.html',
  styleUrls: ['./ot-registration-person.component.scss']
})
export class OtRegistrationPersonComponent implements OnInit {

  public otEvent: OtEvent;
  public otEventInfo: OtEventInfo;
  public personalData: any;
  public registration: any;
  public countries: Country[];
  public registrationPrice: any;
  public formData: any = {};

  public submitted = false;
  public addressVisible = false;

  private cityId: number;
  private otEventId: number;
  public city: City;

  constructor(
      private otEventService: OtEventService,
      private modalService: NgbModal,
      private router: Router,
      private otSessionService: OtSessionService,
      private cityService: OtCityService,
      private countryService: CountryService,
      route: ActivatedRoute) {
    this.cityId = Number.parseInt(route.snapshot.paramMap.get('cityId'), 10);
    this.otEventId = Number.parseInt(route.snapshot.paramMap.get('otEventId'), 10);

    this.registration = this.otSessionService.getRegistration();
    if (! this.registration) {
      console.error('There was no registration saved');
      this.router.navigateByUrl('/city/' + this.cityId + '/ot/event/list');
      return;
    }

    if (! this.registration.person) {
      this.registration.person = {
        address: {}
      };
    } else if (this.registration.person.address && this.registration.person.address.city) {
      this.addressVisible = true;
    }
  }

  ngOnInit() {
    this.otEventService.getOtEventInfoById(this.otEventId).then(otEventInfo => {
      this.otEventInfo = otEventInfo;
      this.otEvent = otEventInfo.otEvent;
      if (this.otEvent.organization.requirePersonAddress) {
        this.addressVisible = true;
      }
    });

    this.cityService.getById(this.cityId).then(city => {
      this.city = city;
    });

    this.formData = {
      birthdateYear: this.registration.person.birthdate ? new Date(this.registration.person.birthdate).getFullYear() : null
    };

    this.countries = [];
    this.countryService.findAll().then(countries => {
      this.countries = countries;
    });

    this.registrationPrice = {
      notes: 'Some registration notes',
      socialGroup: null,
      price: 123
    };
  }

  public openTermsAndConditionsDialog(template): void {
    this.modalService.open(template, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then((result) => {
    }, (reason) => { });
  }

  public countryAutocomplete = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => term.length < 0 ? []
        : this.countries
          .filter(country => (country.localizedName ? country.localizedName.toLowerCase().indexOf(term.toLowerCase()) > -1 : false)
            || (country.englishName ? country.englishName.toLowerCase().indexOf(term.toLowerCase()) > -1 : false))
          .slice(0, 10)))

  public countryInputFormatter = (country: Country) => {
    country.localizedName ? country.localizedName : country.englishName
    if (environment.locale.startsWith('en')) {
      return country.englishName
        ? country.englishName
        : country.localizedName;
    }
    return country.localizedName
      ? country.localizedName
      : country.englishName;
  };

  public countrySelected(event: any): void {
    this.registration.person.address.country = event.item;
  }

  public countryBlured(event: any): void {
    if (! event.srcElement.value) {
      this.registration.person.address.country = null;
      this.registration.person.address.countryCode = null;
    } else if (! this.registration.person.address.country) {
      // If the user did not select any country option, remove the invalid country name from the input
      event.srcElement.value = '';
    } else if ((this.registration.person.address.country.localizedName && event.srcElement.value !== this.registration.person.address.country.localizedName)
        || (! this.registration.person.address.country.localizedName && event.srcElement.value !== this.registration.person.address.country.englishName)) {
      let displayedCountryName;
      if (environment.locale.startsWith('en')) {
        displayedCountryName = this.registration.person.address.country.englishName
          ? this.registration.person.address.country.englishName
          : this.registration.person.address.country.localizedName;
      } else {
        displayedCountryName = this.registration.person.address.country.localizedName
          ? this.registration.person.address.country.localizedName
          : this.registration.person.address.country.englishName;
      }
      event.srcElement.value = displayedCountryName;
    }
  }

  public isAddressRequired(): boolean {
    return this.otEvent && this.otEvent.organization.requirePersonAddress
        || this.registration.person.address.street
        || this.registration.person.address.city
        || this.registration.person.address.postcode
        || this.registration.person.address.country && this.registration.person.address.country.code;
  }

  public goToNextStep(isFormValid: boolean): boolean {
    this.submitted = true;

    if (isFormValid && this.registration.registrationPriceModifiers) {
      for (let i = 0; i < this.registration.registrationPriceModifiers.length; i++) {
        const registrationPriceModifier = this.registration.registrationPriceModifiers[i];
        if (registrationPriceModifier.priceModifier.typeCode === 'SocialDiscount') {
          isFormValid = registrationPriceModifier.registrationSocialDiscount
              && registrationPriceModifier.registrationSocialDiscount.socialGroupId;
        }
      }
    }

    if (! isFormValid) {
      return false;
    }

    if (! this.otEvent.organization.personHasFullBirthdate) {
      this.registration.person.birthdate = new Date(this.formData.birthdateYear, 0, 1);
    }
    this.registration.otEventId = this.otEventId;

    this.otSessionService.setRegistration(this.registration);

    this.router.navigateByUrl('/city/' + this.cityId + '/ot/event/' + this.otEventId + '/registration/summary');
    return true;
  }
}

